import { render, staticRenderFns } from "./SwellInBillList.vue?vue&type=template&id=84cbc8f2&scoped=true&"
import script from "./SwellInBillList.vue?vue&type=script&lang=js&"
export * from "./SwellInBillList.vue?vue&type=script&lang=js&"
import style0 from "./SwellInBillList.vue?vue&type=style&index=0&id=84cbc8f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cbc8f2",
  null
  
)

export default component.exports